export const initializeMoreButtons = () => {
  $('.review-headline-text-actions').on(
    'click',
    '.review-headline-text-actions__show-more',
    e => e.preventDefault() ^ $(e.target)
      .parents('.review-headline-text-actions')
      .addClass('review-headline-text-actions--show-more'),
  );
};
